import React from 'react'
import { Outlet } from 'react-router-dom';
const SaleGoalMngPage = () => {
    return (
        <Outlet />
    )
}

export default SaleGoalMngPage